<template>
  <b-card v-if="item.caseType.caseParams.hasCategorization && (item.caseProblems.length > 0 || visibleCaseManage)">
    <b-row>
      <b-col>
        <div>
          <p class="h6 mb-1"><b>{{$t('views.excmcase.show.categorizationDescription')}}</b>
            <button type="button" class="btn btn-info btn-circle btn-sm ml-2" v-b-tooltip.hover :title="$t('buttons.addCategory')" @click="$bvModal.show('addCaseProblemToCaseModal')" v-if="getIdLink(item.status['@id']) === '1' && visibleCaseManage">
              <i class="fa fa-plus"></i>
            </button>
          </p>
          <table v-if="item.caseProblems.length > 0" class="table table-sm">
            <thead>
            <tr>
              <th class="h6">{{$t('views.excmcaseproblem.list.category')}}</th>
              <th class="h6">{{$t('views.excmcaseproblem.list.problem')}}</th>
            </tr>
            </thead>
            <tbody>
            <tr
              v-for="(caseProblem, key) in item.caseProblems" v-bind:key="key"
            >
              <td>
                <b-row align-h="between">
                  <b-col v-if="visibleCaseManage" cols="2">
                    <b-button class="btn btn-danger btn-circle btn-sm" @click="deleteCaseProblem(caseProblem)" v-if="getIdLink(item.status['@id']) === '1'">
                      <i class="fa fa-times"></i>
                    </b-button>
                  </b-col>
                  <b-col cols="10">
                    {{caseProblem.idProblem.idProblemCategory.title}}
                  </b-col>
                </b-row>
              </td>
              <td>
                {{caseProblem.idProblem.title}}
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import getId from '../../../../../utils/getIdFromLink'

export default {
  name: 'CaseCategorization',
  props: {
    item: {
      type: Object,
      required: true
    },
    visibleCaseManage: {
      required: true
    }
  },
  methods: {
    getIdLink (link) {
      return getId(link)
    },
    deleteCaseProblem (caseProblem) {
      this.$emit('deleteCaseProblem', caseProblem)
    }
  }
}
</script>
